<template>
  <a-list :grid="grid" :data-source="data" :row-key="i => i.id">
    <template #renderItem="{ item }">
      <a-list-item style="margin-top: 25px; margin-bottom: 25px;">
        <slot name="card" :item="item"></slot>
      </a-list-item>
    </template>
  </a-list>
</template>

<script>

export default {
  components: {
  },
  props: ["data", "grid"],
  data: function () {
    return {
    }
  },
  methods: {
    showModal(modalContent) {
      this.$emit('showModal', modalContent);
    }
  }
}
</script>
